import React, { ReactElement } from 'react';
import IconProps from '../IconProps';

export default function IconFrontCar({ color = '#000000', title, ...rest }: IconProps): ReactElement {
    return (
        <svg width='22' height='19' viewBox='0 0 22 19' {...rest} xmlns='http://www.w3.org/2000/svg'>
            {title && <title>{title}</title>}
            <g fill='none' fillRule='evenodd'>
                <g transform='translate(-1 -2)'>
                    <g transform='translate(2 3)'>
                        <rect
                            stroke={color}
                            strokeWidth='2'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                            y='7'
                            width='20'
                            height='8'
                        />
                        <polygon
                            stroke={color}
                            strokeWidth='2'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                            points='4 0 16 0 19 7 1 7'
                        />
                        <rect stroke={color} strokeWidth='2' x='3' y='15' width='1' height='2' rx='0.5' />
                        <rect stroke={color} strokeWidth='2' x='16' y='15' width='1' height='2' rx='0.5' />
                        <circle fill={color} cx='4' cy='11' r='1' />
                        <circle fill={color} cx='16' cy='11' r='1' />
                        <path
                            d='M8,11 L12,11'
                            stroke={color}
                            strokeWidth='2'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                        />
                    </g>
                </g>
            </g>
        </svg>
    );
}
